import SettingScreen from "@/src/screens/settings/settings";

export default function SettingsScreen() {
  return <SettingScreen />;
}
